/**
 * A helper function to handle the response of an HTTP request.
 * @param response an http Response object
 * @returns a Promise that resolves to the JSON representation of the response
 */
export const _handleResponse = async (response: Response): Promise<any> => {
  if (!response.ok) {
    if (response.status === 400) {
      return Promise.reject(await response.json());
    }

    throw new Error(response.statusText);
  }

  return response.json();
};
